import _ from "underscore";
import EscapeStringRegexp from "escape-string-regexp";
import {merge} from "../general";
import Fuse from "fuse.js";
import {searchSettings} from "../fuseSearchSettings";

window.typeAheadSource = typeAheadSource;

export default function typeAheadSource(dataArray, namedCombo, options={}){
  // ["sku-efje", "sku-2323", "another-34343"]
  // inside of map: "sku-ufje"
  // will return each map over: {data: "sku-efje"}
  // finally, map will return: [{data: "sku-efje"}, {data: "sku-2323"}, {data: "another-34343"}]
  // then assign back to dataArray  
  dataArray = _(dataArray).map(function(str){
    return {data: str}
  });

  options = merge(options, searchSettings[namedCombo] || searchSettings.base)
  // override any "keys" key that was passed in because we've transformed
  // the array of strings to array of objects with "data" as only key
  options.keys = ["data"]

  const fuse = new Fuse(dataArray, options)

  return (q, syncResults)=>{
    // var matches, substrRegex;

    // an array that will be populated with substring matches
    // matches = [];

    let res = fuse.search(q)
    // regex used to determine if a string contains the substring `q`
    // substrRegex = new RegExp(EscapeStringRegexp(q), 'i');
    res = _(res).map(function(obj){
      return obj.data
    });
    // iterate through the pool of strings and for any string that
    // contains the substring `q`, add it to the `matches` array
    // _(dataArray).each((str)=>{
    //   if(substrRegex.test(str)){
    //     matches.push(str);
    //   }
    // });
    syncResults(res);
  }
}



// WEBPACK FOOTER //
// ./src/utilities/typeAheadSource/index.js